"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var shared_1 = require("../../../shared");

var mobx_react_1 = require("mobx-react");

var assets_1 = require("../../../assets/assets");

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var Asset_meta_1 = require("./Asset.meta");

var appendCacheQueryStringRaw = ksys_app_template_1.appsManager.utils.appendCacheQueryString;

exports.AssetContextValue = function (assets, assetRegisters, cacheOptions) {
  if (assets === void 0) {
    assets = {};
  }

  if (assetRegisters === void 0) {
    assetRegisters = [];
  }

  var assetRegisterByFileName = ksys_app_template_1.utils.collection.pivotCollection(assetRegisters, function (assetRegister) {
    return assetRegister.fileName;
  });

  var appendCacheQueryString = function appendCacheQueryString(fileName) {
    var assetRegister = assetRegisterByFileName[fileName];

    if (assetRegister) {
      fileName = appendCacheQueryStringRaw(fileName, assetRegister, cacheOptions);
    }

    return fileName;
  };

  var getAsset = function getAsset(key) {
    var asset = ksys_app_template_1.utils.get(assets, key);
    var response = appendCacheQueryString(asset || key);
    return response;
  };

  var hasAsset = function hasAsset(key) {
    var asset = ksys_app_template_1.utils.get(assets, key, null);
    return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(asset);
  };

  var baseUrl = function baseUrl() {
    return assets && assets.baseUrl || '';
  };

  return {
    assets: assets,
    getAsset: getAsset,
    hasAsset: hasAsset,
    baseUrl: baseUrl,
    appendCacheQueryString: appendCacheQueryString
  };
};

exports.AssetContext = react_1.createContext(exports.AssetContextValue(assets_1.assets));

var Asset =
/** @class */
function (_super) {
  __extends(Asset, _super);

  function Asset() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.categoryKey = Asset_meta_1.ASSET_CATEGORY_KEY;
    _this.componentKey = Asset_meta_1.ASSET_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Asset.prototype, "asset", {
    get: function get() {
      var children = this.props.children;

      if (typeof children !== 'string' || !this.context || !this.context.assets) {
        return children;
      }

      return this.context.getAsset(children);
    },
    enumerable: true,
    configurable: true
  });

  Asset.prototype.render = function () {
    return react_1.default.createElement(react_1.Fragment, null, this.asset);
  };

  Asset.contextType = exports.AssetContext;
  Asset = __decorate([mobx_react_1.observer], Asset);
  return Asset;
}(shared_1.ComponentBase);

exports.Asset = Asset;
exports.default = Asset;